// =============================================
// index.jsx - React 앱의 시작점
// =============================================
// 이 파일은 React 앱을 HTML 페이지에 연결시켜줘.
// public/index.html의 <div id="root"> 안에
// App.jsx를 집어넣는 역할이야.
// =============================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// HTML에서 id="root"인 요소를 찾아서 React 앱을 연결해
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* StrictMode: 개발 중에 문제가 있으면 경고를 보내줘 */}
    <App />
  </React.StrictMode>
);
